// extracted by css-extract-rspack-plugin
export default {"chartWrapper":"iSh2i","chart":"_dbYG"};